import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const StyledTitleCell = styled.div`
  max-width: 200px;
  padding: 8px;
  white-space: pre-wrap;
  ${typographyV2.bodySm}
`;

export const StyledDescriptionCell = styled.div`
  padding: 8px;
  white-space: pre-wrap;
  ${typographyV2.bodySm};
`;

export const StyledRatingPill = styled.div`
  width: 100px;
`;

export const ValueCell = styled.div`
  padding: 8px;
  white-space: pre-wrap;
  ${typographyV2.bodySm};
`;

export const Title = styled.h2`
  ${typographyV2.titleMd}
  color: var(--text-default);
  margin-bottom: 16px;
`;
